import React from 'react';

import './Note.scss';

const Note = ({ children }) => <aside className="note monospace">{children}</aside>;

export default Note;
